import { InternalAnnouncementFormType } from 'components/internal-announcements/InternalAnnouncementForm';

export const updateInternalAnnouncementInitialValues: Partial<InternalAnnouncementFormType> = {};
